<template>
  <div>
    <el-card shadow="always">
      <el-page-header @back="back" title :content="title"></el-page-header>
    </el-card>
    <el-card>
      <el-form label-position="top" @submit.native.prevent>
        <el-row :gutter="5" class="matrix-service">
          <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
            <el-form-item :label="$t('servico')">
              <el-select
                clearable
                filterable
                :value="serviceId"
                :placeholder="$t('selecione-uma-opcao')"
                @change="selectService($event)"
              >
                <el-option
                  v-for="row of services"
                  v-bind:key="row.id"
                  :label="`${row.name} (${row.code})`"
                  :value="row.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
            <el-form-item label=" ">
              <el-button type="primary" :disabled="!serviceId" @click="consult()">
                {{ $t("consultar") }}
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-alert
        v-if="!service"
        :title="$t('selecione-um-servico-para-editar-os-prazos')"
        type="info"
        :closable="false"
        show-icon
      ></el-alert>
      <el-alert
        v-if="service && empty"
        class="matrix-alert"
        :title="$t('servico-sem-prazos')"
        type="warning"
        :closable="false"
        show-icon
      ></el-alert>
      <div v-if="service" class="matrix-scroll">
        <table class="matrix">
          <thead>
            <tr>
              <th class="corner">{{ $t("origem") }} \ {{ $t("destino") }}</th>
              <th v-for="destiny of states" v-bind:key="destiny.id" :title="destiny.name">
                {{ destiny.id }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="source of states" v-bind:key="source.id">
              <th class="source" :title="source.name">{{ source.id }}</th>
              <td
                v-for="destiny of states"
                v-bind:key="destiny.id"
                :class="cellClass(source.id, destiny.id)"
              >
                <el-input
                  size="mini"
                  maxlength="3"
                  :value="cells[key(source.id, destiny.id)]"
                  @input="change(source.id, destiny.id, $event)"
                ></el-input>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="service" class="matrix-actions">
        <el-button type="warning" :disabled="changed.length === 0" @click="save()">
          {{ $t("salvar") }}
          <span v-if="changed.length > 0">({{ changed.length }})</span>
        </el-button>
        <el-button type="danger" @click="back()">{{ $t("voltar") }}</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import { PriceDeadLineService } from "@/services/customers/price.deadline.service";
import { ServicesService } from "@/services/customers/services.services";
import { StateEnum } from "@/xpost/enums/StateEnum";
import { i18n } from "@/plugin/i18n";

export default {
  name: "DeadlineStateMatrix",
  data() {
    return {
      states: StateEnum,
      services: [],
      serviceId: "",
      service: null,
      empty: false,
      original: {},
      cells: {},
      invalid: "",
    };
  },
  computed: {
    title() {
      const vm = this;
      if (!vm.service) {
        return i18n.tc("prazos");
      }
      return `${i18n.tc("prazos")} — ${vm.service.name} (${vm.service.code})`;
    },
    changed() {
      const vm = this;
      const list = [];
      for (const pair of Object.keys(vm.cells)) {
        const value = vm.cells[pair];
        if (value === "") {
          continue;
        }
        const current = vm.original[pair];
        if (current === undefined || String(current) !== value) {
          list.push({ pair, days: Number(value) });
        }
      }
      return list;
    },
  },
  methods: {
    key(source, destiny) {
      return `${source}|${destiny}`;
    },
    back() {
      const vm = this;
      vm.$router.replace({ name: "home" });
    },
    cellClass(source, destiny) {
      const vm = this;
      const pair = vm.key(source, destiny);
      const value = vm.cells[pair];
      const current = vm.original[pair];
      return {
        diagonal: source === destiny,
        dirty: value !== "" && (current === undefined || String(current) !== value),
        off: value === "0",
        error: vm.invalid === pair,
      };
    },
    change(source, destiny, value) {
      const vm = this;
      const pair = vm.key(source, destiny);
      const digits = String(value).replace(/\D/g, "");
      vm.$set(vm.cells, pair, digits);
      if (vm.invalid === pair) {
        vm.invalid = "";
      }
    },
    paint(items) {
      const vm = this;
      const original = {};
      const cells = {};
      for (const source of vm.states) {
        for (const destiny of vm.states) {
          cells[vm.key(source.id, destiny.id)] = "";
        }
      }
      for (const item of items) {
        const pair = vm.key(item.sourceState, item.destinyState);
        original[pair] = item.days;
        cells[pair] = String(item.days);
      }
      vm.original = original;
      vm.cells = cells;
      vm.invalid = "";
    },
    hide() {
      const vm = this;
      vm.service = null;
      vm.empty = false;
      vm.paint([]);
    },
    selectService(value) {
      const vm = this;
      if (vm.service && vm.service.id === value) {
        vm.serviceId = value;
        return;
      }
      if (vm.changed.length === 0) {
        vm.serviceId = value || "";
        return vm.hide();
      }
      vm.$confirm(i18n.tc("descartar-alteracoes-servico"), {
        type: "warning",
      })
        .then(() => {
          vm.serviceId = value || "";
          vm.hide();
        })
        .catch(() => {
          const current = vm.serviceId;
          vm.serviceId = "";
          vm.$nextTick(() => {
            vm.serviceId = current;
          });
        });
    },
    getServices() {
      const vm = this;
      ServicesService.actives()
        .then((response) => {
          vm.services = (response && response.records) || [];
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        });
    },
    consult() {
      const vm = this;
      const service = vm.services.find((row) => row.id === vm.serviceId);
      if (!service) {
        return;
      }
      if (vm.changed.length === 0) {
        return vm.get(service);
      }
      vm.$confirm(i18n.tc("descartar-alteracoes-servico"), {
        type: "warning",
      })
        .then(() => vm.get(service))
        .catch(() => {});
    },
    get(service) {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      PriceDeadLineService.listStates(service.id)
        .then((response) => {
          const items = response || [];
          vm.paint(items);
          vm.empty = items.length === 0;
          vm.service = service;
        })
        .catch((error) => {
          vm.hide();
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    save() {
      const vm = this;
      const changed = vm.changed;
      if (!vm.service || changed.length === 0) {
        return;
      }
      const keys = changed.map((row) => row.pair);
      const deadlines = changed.map((row) => {
        const parts = row.pair.split("|");
        return {
          sourceState: parts[0],
          destinyState: parts[1],
          days: row.days,
        };
      });
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      PriceDeadLineService.saveStates(vm.service.id, deadlines)
        .then((response) => {
          const items = response || [];
          vm.paint(items);
          vm.empty = items.length === 0;
          vm.$message({
            type: "success",
            message: i18n.tc("prazos-salvos-sucesso"),
          });
        })
        .catch((error) => {
          const message = String(error);
          const item = message.match(/^Item (\d+):/);
          if (item) {
            vm.invalid = keys[Number(item[1]) - 1] || "";
          }
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
  },
  beforeRouteLeave(to, from, next) {
    const vm = this;
    if (vm.changed.length === 0) {
      return next();
    }
    vm.$confirm(i18n.tc("descartar-alteracoes"), {
      type: "warning",
    })
      .then(() => next())
      .catch(() => next(false));
  },
  mounted() {
    const vm = this;
    vm.paint([]);
    vm.getServices();
  },
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}
.matrix-service >>> .el-form-item {
  margin-bottom: 10px;
}
.matrix-service >>> .el-form-item__label {
  padding-bottom: 0;
  line-height: 24px;
}
.matrix-service >>> .el-select {
  width: 100%;
}
.matrix-alert {
  margin-bottom: 10px;
}
.matrix-scroll {
  overflow: auto;
  max-height: calc(100vh - 300px);
  border: 1px solid #ebeef5;
}
table.matrix {
  border-collapse: separate;
  border-spacing: 0;
}
table.matrix th {
  background-color: #f5f7fa;
  color: #909399;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  padding: 4px 6px;
  border-right: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}
table.matrix thead th {
  position: sticky;
  top: 0;
  z-index: 2;
}
table.matrix th.source {
  position: sticky;
  left: 0;
  z-index: 2;
}
table.matrix th.corner {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 3;
  white-space: nowrap;
}
table.matrix td {
  width: 56px;
  min-width: 56px;
  padding: 1px;
  border-right: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}
table.matrix td.diagonal {
  background-color: #fafafa;
}
table.matrix td.off >>> .el-input__inner {
  color: #c0c4cc;
}
table.matrix td.dirty {
  background-color: #fdf6ec;
}
table.matrix td.error {
  background-color: #fef0f0;
}
table.matrix td >>> .el-input__inner {
  border: none;
  background-color: transparent;
  text-align: center;
  padding: 0 4px;
}
</style>
